import React, { useState, useEffect } from "react";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Avatar from 'react-avatar';
import { useKeycloak } from "@react-keycloak/web";
import useAxios from "../helpers/useAxios";

const Navigation = (props) => {
  const { keycloak } = useKeycloak();

  const [company, setCompany] = useState(
    getSessionCompany()
  );
  const [nifAdmin, setNifAdmin] = useState(
    getSessionNifAdmin()
  );

  function getSessionCompany() {
    const stored = sessionStorage.getItem('company');

    try 
    {
      return JSON.parse(stored);
    }
    catch
    {
      return null;
    }
  }

  function getSessionIsAdmin() {
    const stored = sessionStorage.getItem('ADM');

    try 
    {
      if (stored)
      {
        return JSON.parse(stored);
      }
      else
      {
        return false;
      }
    }
    catch
    {
      return false;
    }
  }

  function getSessionNifAdmin() {
    const stored = sessionStorage.getItem('nifAdmin');

    try 
    {
      if (stored)
      {
        return JSON.parse(stored);
      }
      else
      {
        return '';
      }
    }
    catch
    {
      return '';
    }
  }

  const { fetch, data, error, loaded } = useAxios("", "", {}, true);

  useEffect(() => {
    if (company === null)
    {
      fetch("POST", "/User/user-detail", { nif: keycloak.tokenParsed.preferred_username });

      fetch("POST", "/User/create-login-history", { nif: keycloak.tokenParsed.preferred_username });
    }
  }, [company]);

  useEffect(() => {
    if (loaded && error.length === 0)
    {
      setCompany(data.companyName)

      sessionStorage.setItem('company', data.companyName);
      sessionStorage.setItem('nifCompany', data.companyNif);
      sessionStorage.setItem('ADM', data.isAdmin);
    }
  }, [data]);

 return (
  <div className="col-md-12 bg-white rounded-4 p-3 mb-4">
    <div className="text-center mb-3">
      <Avatar name={keycloak.tokenParsed.given_name + " " + keycloak.tokenParsed.family_name} color="#9DB1C9" size="80" round={true} />
      <p className="mt-3 mb-1" style={{fontSize:'16px', fontWeight:'600'}}>{keycloak.tokenParsed.given_name + " " + keycloak.tokenParsed.family_name}</p>
      <p style={{fontSize:'12px', color:'#3F5B78'}}>{company}</p>
    </div>
    {getSessionIsAdmin() && (
        <div className="text-center mb-5">
          <label style={{color:'#3F5B78', fontWeight:'600'}}>NIF utilizador</label>
          <input type="text" className="form-control" value={nifAdmin} onChange={(e) => {
            sessionStorage.setItem('nifAdmin', e.target.value);
            setNifAdmin(e.target.value);
          }} />
        </div>
      )}
    <Nav className="nav navbar-nav sidebar" activeKey={props.activeKey}>
      <Navbar.Text>
        CARTEIRA
      </Navbar.Text>
      <Nav.Item>
        <Nav.Link href="/dashboard" className="mt-2">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-1">
            <g stroke="none" strokeWidth="1" fill={(props.activeKey === "/dashboard" ? '#0071CE' : '#3F5B78')} fillRule="evenodd">
              <path d="M1.6,3.9272 L5.8904,3.9272 L5.8904,1.6 L1.6,1.6 L1.6,3.9272 Z M5.8904,4.79616347e-14 L1.6,4.79616347e-14 C0.7176,4.79616347e-14 -6.83897383e-14,0.7176 -6.83897383e-14,1.6 L-6.83897383e-14,4.7272 C-6.83897383e-14,5.1696 0.3576,5.5272 0.8,5.5272 L6.6904,5.5272 C7.1328,5.5272 7.4904,5.1696 7.4904,4.7272 L7.4904,1.6 C7.4904,0.7176 6.7728,4.79616347e-14 5.8904,4.79616347e-14 L5.8904,4.79616347e-14 Z M10.10936,14.4 L10.10936,12.0728 L14.39976,12.0728 L14.40136,14.4 L10.10936,14.4 Z M15.19976,10.4728 L9.30936,10.4728 C8.86696,10.4728 8.50936,10.8304 8.50936,11.2728 L8.50936,14.4 C8.50936,15.2824 9.22696,16 10.10936,16 L14.39976,16 C15.28216,16 15.99976,15.2824 15.99976,14.4 L15.99976,11.2728 C15.99976,10.8304 15.64216,10.4728 15.19976,10.4728 L15.19976,10.4728 Z M10.1096,7.8544 L14.4,7.8544 L14.4,1.6 L10.1096,1.6 L10.1096,7.8544 Z M14.4,-8.8817842e-16 L10.1096,-8.8817842e-16 C9.2272,-8.8817842e-16 8.5096,0.7176 8.5096,1.6 L8.5096,8.6544 C8.5096,9.0968 8.8672,9.4544 9.3096,9.4544 L15.2,9.4544 C15.6424,9.4544 16,9.0968 16,8.6544 L16,1.6 C16,0.7176 15.2824,-8.8817842e-16 14.4,-8.8817842e-16 L14.4,-8.8817842e-16 Z M1.6,14.4 L1.6,8.1456 L5.8904,8.1456 L5.892,14.4 L1.6,14.4 Z M6.6904,6.5456 L0.8,6.5456 C0.3576,6.5456 -6.83897383e-14,6.9032 -6.83897383e-14,7.3456 L-6.83897383e-14,14.4 C-6.83897383e-14,15.2824 0.7176,16 1.6,16 L5.8904,16 C6.7728,16 7.4904,15.2824 7.4904,14.4 L7.4904,7.3456 C7.4904,6.9032 7.1328,6.5456 6.6904,6.5456 L6.6904,6.5456 Z" />
            </g>
          </svg>
          Dashboard
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link href="/extratoindividual" className="mt-2">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-1">
            <g stroke="none" strokeWidth="1" fill={(props.activeKey === "/extratoindividual" ? '#0071CE' : '#3F5B78')} fillRule="evenodd">
              <path d="M1.6,3.9272 L5.8904,3.9272 L5.8904,1.6 L1.6,1.6 L1.6,3.9272 Z M5.8904,4.79616347e-14 L1.6,4.79616347e-14 C0.7176,4.79616347e-14 -6.83897383e-14,0.7176 -6.83897383e-14,1.6 L-6.83897383e-14,4.7272 C-6.83897383e-14,5.1696 0.3576,5.5272 0.8,5.5272 L6.6904,5.5272 C7.1328,5.5272 7.4904,5.1696 7.4904,4.7272 L7.4904,1.6 C7.4904,0.7176 6.7728,4.79616347e-14 5.8904,4.79616347e-14 L5.8904,4.79616347e-14 Z M10.10936,14.4 L10.10936,12.0728 L14.39976,12.0728 L14.40136,14.4 L10.10936,14.4 Z M15.19976,10.4728 L9.30936,10.4728 C8.86696,10.4728 8.50936,10.8304 8.50936,11.2728 L8.50936,14.4 C8.50936,15.2824 9.22696,16 10.10936,16 L14.39976,16 C15.28216,16 15.99976,15.2824 15.99976,14.4 L15.99976,11.2728 C15.99976,10.8304 15.64216,10.4728 15.19976,10.4728 L15.19976,10.4728 Z M10.1096,7.8544 L14.4,7.8544 L14.4,1.6 L10.1096,1.6 L10.1096,7.8544 Z M14.4,-8.8817842e-16 L10.1096,-8.8817842e-16 C9.2272,-8.8817842e-16 8.5096,0.7176 8.5096,1.6 L8.5096,8.6544 C8.5096,9.0968 8.8672,9.4544 9.3096,9.4544 L15.2,9.4544 C15.6424,9.4544 16,9.0968 16,8.6544 L16,1.6 C16,0.7176 15.2824,-8.8817842e-16 14.4,-8.8817842e-16 L14.4,-8.8817842e-16 Z M1.6,14.4 L1.6,8.1456 L5.8904,8.1456 L5.892,14.4 L1.6,14.4 Z M6.6904,6.5456 L0.8,6.5456 C0.3576,6.5456 -6.83897383e-14,6.9032 -6.83897383e-14,7.3456 L-6.83897383e-14,14.4 C-6.83897383e-14,15.2824 0.7176,16 1.6,16 L5.8904,16 C6.7728,16 7.4904,15.2824 7.4904,14.4 L7.4904,7.3456 C7.4904,6.9032 7.1328,6.5456 6.6904,6.5456 L6.6904,6.5456 Z" />
            </g>
          </svg>
          Extrato individual
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link href="/extratoconsolidado" className="mt-2">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-1">
            <g stroke="none" strokeWidth="1" fill={(props.activeKey === "/extratoconsolidade" ? '#0071CE' : '#3F5B78')} fillRule="evenodd">
              <path d="M1.6,3.9272 L5.8904,3.9272 L5.8904,1.6 L1.6,1.6 L1.6,3.9272 Z M5.8904,4.79616347e-14 L1.6,4.79616347e-14 C0.7176,4.79616347e-14 -6.83897383e-14,0.7176 -6.83897383e-14,1.6 L-6.83897383e-14,4.7272 C-6.83897383e-14,5.1696 0.3576,5.5272 0.8,5.5272 L6.6904,5.5272 C7.1328,5.5272 7.4904,5.1696 7.4904,4.7272 L7.4904,1.6 C7.4904,0.7176 6.7728,4.79616347e-14 5.8904,4.79616347e-14 L5.8904,4.79616347e-14 Z M10.10936,14.4 L10.10936,12.0728 L14.39976,12.0728 L14.40136,14.4 L10.10936,14.4 Z M15.19976,10.4728 L9.30936,10.4728 C8.86696,10.4728 8.50936,10.8304 8.50936,11.2728 L8.50936,14.4 C8.50936,15.2824 9.22696,16 10.10936,16 L14.39976,16 C15.28216,16 15.99976,15.2824 15.99976,14.4 L15.99976,11.2728 C15.99976,10.8304 15.64216,10.4728 15.19976,10.4728 L15.19976,10.4728 Z M10.1096,7.8544 L14.4,7.8544 L14.4,1.6 L10.1096,1.6 L10.1096,7.8544 Z M14.4,-8.8817842e-16 L10.1096,-8.8817842e-16 C9.2272,-8.8817842e-16 8.5096,0.7176 8.5096,1.6 L8.5096,8.6544 C8.5096,9.0968 8.8672,9.4544 9.3096,9.4544 L15.2,9.4544 C15.6424,9.4544 16,9.0968 16,8.6544 L16,1.6 C16,0.7176 15.2824,-8.8817842e-16 14.4,-8.8817842e-16 L14.4,-8.8817842e-16 Z M1.6,14.4 L1.6,8.1456 L5.8904,8.1456 L5.892,14.4 L1.6,14.4 Z M6.6904,6.5456 L0.8,6.5456 C0.3576,6.5456 -6.83897383e-14,6.9032 -6.83897383e-14,7.3456 L-6.83897383e-14,14.4 C-6.83897383e-14,15.2824 0.7176,16 1.6,16 L5.8904,16 C6.7728,16 7.4904,15.2824 7.4904,14.4 L7.4904,7.3456 C7.4904,6.9032 7.1328,6.5456 6.6904,6.5456 L6.6904,6.5456 Z" />
            </g>
          </svg>
          Extrato consolidado
        </Nav.Link>
      </Nav.Item>
      <Nav.Item className="mb-5">
        <Nav.Link href="/registarpedido" className="mt-2">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-1">
            <g stroke="none" strokeWidth="1" fill={(props.activeKey === "/registarpedido" ? '#0071CE' : '#3F5B78')} fillRule="evenodd">
              <path d="M1.6,3.9272 L5.8904,3.9272 L5.8904,1.6 L1.6,1.6 L1.6,3.9272 Z M5.8904,4.79616347e-14 L1.6,4.79616347e-14 C0.7176,4.79616347e-14 -6.83897383e-14,0.7176 -6.83897383e-14,1.6 L-6.83897383e-14,4.7272 C-6.83897383e-14,5.1696 0.3576,5.5272 0.8,5.5272 L6.6904,5.5272 C7.1328,5.5272 7.4904,5.1696 7.4904,4.7272 L7.4904,1.6 C7.4904,0.7176 6.7728,4.79616347e-14 5.8904,4.79616347e-14 L5.8904,4.79616347e-14 Z M10.10936,14.4 L10.10936,12.0728 L14.39976,12.0728 L14.40136,14.4 L10.10936,14.4 Z M15.19976,10.4728 L9.30936,10.4728 C8.86696,10.4728 8.50936,10.8304 8.50936,11.2728 L8.50936,14.4 C8.50936,15.2824 9.22696,16 10.10936,16 L14.39976,16 C15.28216,16 15.99976,15.2824 15.99976,14.4 L15.99976,11.2728 C15.99976,10.8304 15.64216,10.4728 15.19976,10.4728 L15.19976,10.4728 Z M10.1096,7.8544 L14.4,7.8544 L14.4,1.6 L10.1096,1.6 L10.1096,7.8544 Z M14.4,-8.8817842e-16 L10.1096,-8.8817842e-16 C9.2272,-8.8817842e-16 8.5096,0.7176 8.5096,1.6 L8.5096,8.6544 C8.5096,9.0968 8.8672,9.4544 9.3096,9.4544 L15.2,9.4544 C15.6424,9.4544 16,9.0968 16,8.6544 L16,1.6 C16,0.7176 15.2824,-8.8817842e-16 14.4,-8.8817842e-16 L14.4,-8.8817842e-16 Z M1.6,14.4 L1.6,8.1456 L5.8904,8.1456 L5.892,14.4 L1.6,14.4 Z M6.6904,6.5456 L0.8,6.5456 C0.3576,6.5456 -6.83897383e-14,6.9032 -6.83897383e-14,7.3456 L-6.83897383e-14,14.4 C-6.83897383e-14,15.2824 0.7176,16 1.6,16 L5.8904,16 C6.7728,16 7.4904,15.2824 7.4904,14.4 L7.4904,7.3456 C7.4904,6.9032 7.1328,6.5456 6.6904,6.5456 L6.6904,6.5456 Z" />
            </g>
          </svg>
          Registar pedido
        </Nav.Link>
      </Nav.Item>
      <Navbar.Text>
          OUTRAS OPÇÕES
      </Navbar.Text>
      <Nav.Item className="mb-5">
        <Nav.Link href="/dadospessoais" className="mt-2">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-1">
            <g stroke="none" strokeWidth="1" fill={(props.activeKey === "/dadospessoais" ? '#0071CE' : '#3F5B78')} fillRule="evenodd">
              <path d="M1.6,3.9272 L5.8904,3.9272 L5.8904,1.6 L1.6,1.6 L1.6,3.9272 Z M5.8904,4.79616347e-14 L1.6,4.79616347e-14 C0.7176,4.79616347e-14 -6.83897383e-14,0.7176 -6.83897383e-14,1.6 L-6.83897383e-14,4.7272 C-6.83897383e-14,5.1696 0.3576,5.5272 0.8,5.5272 L6.6904,5.5272 C7.1328,5.5272 7.4904,5.1696 7.4904,4.7272 L7.4904,1.6 C7.4904,0.7176 6.7728,4.79616347e-14 5.8904,4.79616347e-14 L5.8904,4.79616347e-14 Z M10.10936,14.4 L10.10936,12.0728 L14.39976,12.0728 L14.40136,14.4 L10.10936,14.4 Z M15.19976,10.4728 L9.30936,10.4728 C8.86696,10.4728 8.50936,10.8304 8.50936,11.2728 L8.50936,14.4 C8.50936,15.2824 9.22696,16 10.10936,16 L14.39976,16 C15.28216,16 15.99976,15.2824 15.99976,14.4 L15.99976,11.2728 C15.99976,10.8304 15.64216,10.4728 15.19976,10.4728 L15.19976,10.4728 Z M10.1096,7.8544 L14.4,7.8544 L14.4,1.6 L10.1096,1.6 L10.1096,7.8544 Z M14.4,-8.8817842e-16 L10.1096,-8.8817842e-16 C9.2272,-8.8817842e-16 8.5096,0.7176 8.5096,1.6 L8.5096,8.6544 C8.5096,9.0968 8.8672,9.4544 9.3096,9.4544 L15.2,9.4544 C15.6424,9.4544 16,9.0968 16,8.6544 L16,1.6 C16,0.7176 15.2824,-8.8817842e-16 14.4,-8.8817842e-16 L14.4,-8.8817842e-16 Z M1.6,14.4 L1.6,8.1456 L5.8904,8.1456 L5.892,14.4 L1.6,14.4 Z M6.6904,6.5456 L0.8,6.5456 C0.3576,6.5456 -6.83897383e-14,6.9032 -6.83897383e-14,7.3456 L-6.83897383e-14,14.4 C-6.83897383e-14,15.2824 0.7176,16 1.6,16 L5.8904,16 C6.7728,16 7.4904,15.2824 7.4904,14.4 L7.4904,7.3456 C7.4904,6.9032 7.1328,6.5456 6.6904,6.5456 L6.6904,6.5456 Z" />
            </g>
          </svg>
          Dados Pessoais
        </Nav.Link>
      </Nav.Item>  
    </Nav>    
  </div>
 );
};

export default Navigation;
